import { render } from "./forgotpassword.vue?vue&type=template&id=eb7be3c6&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"

import "./forgotpassword.vue?vue&type=style&index=0&id=eb7be3c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb7be3c6"]])

export default __exports__